import { useThema } from "@/stores/Thema"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { FormEvent } from "react"
import { Button } from "@/components/Button"
import { Icon } from "@/components/Icon"
import { IconTrash } from "@tabler/icons-react"
import { Dialog, DialogTrigger, Heading } from "react-aria-components"
import { Modal } from "@/components/Modal/Modal"
import { Form } from "@/components/Form/Form"
import { chain } from "react-aria"

export const DeleteThemeButton = ({id, versionId, name}: {id: string, name: string, versionId?: string}) => {
    const thema = useThema()
    const queryClient = useQueryClient()
    const updateMutation = useMutation({
        mutationFn: thema.deleteTheme,
        onSuccess: () => queryClient.invalidateQueries({queryKey: ["history"]})
    })

    const del = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        const evt = e.nativeEvent as SubmitEvent

        evt.submitter?.setAttribute("disabled", "true")
        updateMutation.mutate({id, versionId})
    }

    return (
        <DialogTrigger>
            <Button treatment="outline" size="sm" variant="destructive">
                <Icon icon={IconTrash}/>
            </Button>
            <Modal isDismissable className="w-[650px] max-h-[400px]">
                <Dialog className="outline-none max-h-[inherit] p-8 dark">
                    {({close}) => <>
                        <Heading className="text-xl mb-2">Are you sure you want to delete theme <strong>"{name}"</strong>?!</Heading>
                        <Form onSubmit={chain(del, close)}>
                            <div className="flex gap-2 justify-end">
                                <Button onPress={close} treatment="link">CANCEL</Button>
                                <Button variant="destructive" type="submit" className="flex">DELETE</Button>
                            </div>
                        </Form>
                    </>}
                </Dialog>
            </Modal>
        </DialogTrigger>
    )
}